export const SET_LOCATION = 'SET_LOCATION'
export const SET_DEVICES = 'SET_DEVICES'
export const SET_DEVICE_TYPES = 'SET_DEVICE_TYPES'

export const SESSION_DEVICES = 'SESSION_DEVICES'
export const SESSION_DEVICE_TYPES = 'SESSION_DEVICE_TYPES'
